var lastId = 0;

export default function () {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'id';

  lastId++;
  return '' + prefix + lastId;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/carbon-components-react/es/tools/uniqueId.js
// module id = 68
// module chunks = 0